if (!customElements.get("collection-load-previous")) {
  class CollectionLoadPrevious extends HTMLElement {
    constructor() {
      super();

      this.btnLoadPrevious = this.querySelector(".js-btn-load-previous");
      this.productGrid = document.querySelector("#product-grid");
      this.enableRandom = this.dataset.enableRandom === 'true';

      this.setProperties();

      const updateProductCount = () => {
        const productCount = document.querySelectorAll('.collection__grid .product-card').length;
        const productCountOfAll = document.querySelector('.collection-facets__product-count .product-count-of-all');
        if (productCountOfAll) {
          productCountOfAll.innerText = productCount;
        }
      };
      updateProductCount();

      this.btnLoadPrevious.addEventListener('click', e => {
        e.preventDefault();
        this.btnLoadPrevious.setAttribute('disabled', true);

        this.loadPreviousProducts().then(() => {
          updateProductCount();
          this.btnLoadPrevious.removeAttribute('disabled');
        });
      });
      this.checkPageParameter();
    }

    checkPageParameter() {
      const urlParams = new URLSearchParams(window.location.search);
      const page = urlParams.get("page") || "1";
      const previousButton = document.querySelector("collection-load-previous");

      if (page === "1" && previousButton) {
        previousButton.style.display = "none";
      }
    }

    setProperties() {
      this.productGrid = document.querySelector("#product-grid");
      this.btnLoadPrevious = this.querySelector(".js-btn-load-previous");
    }

    /**
     * Fisher-Yates shuffle algorithm
     * @param {Array} array - Array to shuffle
     * @returns {Array} - Shuffled array
     */
    shuffleArray(array) {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    }

    /**
     * Shuffle new products before prepending to grid
     * @param {Array} products - Array of product elements
     * @returns {Array} - Shuffled array of product elements
     */
    shuffleNewProducts(products) {
      if (!this.enableRandom) {
        return products;
      }

      // Separate card-text from products
      const cardTextElements = products.filter(el => 
        el.classList.contains('js-card-text')
      );
      const productCards = products.filter(el => 
        !el.classList.contains('js-card-text')
      );

      // Shuffle only product cards
      const shuffledProducts = this.shuffleArray(productCards);

      // If there was a card-text, insert it back at a reasonable position
      if (cardTextElements.length > 0) {
        cardTextElements.forEach(cardText => {
          const insertIndex = Math.min(7, shuffledProducts.length);
          shuffledProducts.splice(insertIndex, 0, cardText);
        });
      }

      return shuffledProducts;
    }

    async loadPreviousProducts() {
      try {
        const prevPageResponse = await fetch(
          `${this.btnLoadPrevious.dataset.href}`
        );
        const prevPageText = await prevPageResponse.text();

        const prevPageHTML = new DOMParser().parseFromString(
          prevPageText,
          "text/html"
        );

        const productGridContainer = prevPageHTML.querySelector(
          "#ProductGridContainer"
        );
        const productGrid = productGridContainer.querySelector("#product-grid");

        // Get new products as array of elements
        let newProducts = Array.from(productGrid.children);

        // Shuffle new products if random is enabled
        newProducts = this.shuffleNewProducts(newProducts);

        // Get reference to first child of current grid for insertion point
        const firstChild = this.productGrid.firstChild;

        // Prepend each new product in reverse order to maintain shuffled order
        newProducts.reverse().forEach(product => {
          if (firstChild) {
            this.productGrid.insertBefore(product, firstChild);
          } else {
            this.productGrid.appendChild(product);
          }
        });

        const prevButtonOnNewPage = prevPageHTML.querySelector(
          ".js-btn-load-previous"
        );
        if (prevButtonOnNewPage) {
          const prevPageLink = prevButtonOnNewPage.dataset.href;
          this.btnLoadPrevious.dataset.href = prevPageLink;
        }

        const currentUrl = new URL(window.location.href);
        const currentUrlParams = new URLSearchParams(currentUrl.search);
        const currentPage = parseInt(currentUrlParams.get("page"), 10) || 1;

        currentUrlParams.set("page", currentPage - 1);
        currentUrl.search = currentUrlParams.toString();

        history.replaceState({}, "", currentUrl.toString());

        this.checkPageParameter();
      } catch (error) {
        console.error(error);
        alert(error.message);
      } finally {
        this.btnLoadPrevious.removeAttribute("disabled");
      }
    }
  }

  customElements.define("collection-load-previous", CollectionLoadPrevious);
}